module.exports = __webpack_public_path__ + "static/ivonne-atmojo-23e8124c48eb17b1330f4d007622f2cd.jpg";